export enum ProcesoResultado {
  ERROR = "ERROR",
  WARNING = "WARNING",
  SUCCESS = "SUCCESS"
}

export interface MetaClubMensual {
  periodo: string;
  metaAcumulada: number;
  mes: string;
}

export interface MetaClub {
  numeroRegion: number;
  claveClub: string;
  idClub: number;
  club: string;
  metaAcumulada: number;
  metasMensuales: MetaClubMensual[];
  resultado: ProcesoResultado;
  mensaje: string;
}

export interface MetaRegionMensual {
  periodo: string;
  metaPresupuestada: number;
  mes: string;
}

export interface MetaRegion {
  numeroRegion: number;
  metasMensuales: MetaRegionMensual[];
  resultado: ProcesoResultado;
  mensaje: string;
}

export default interface AnualidadMetaCarga {
  periodo: string;
  meses: number;
  metaAcumuladaTotal: number;
  metaContactCenter: number;
  metasClubes: MetaClub[];
  metasRegiones: MetaRegion[];
  resultado: ProcesoResultado;
  mensaje: string;
}
